import { usePath } from "../../libs/path/PathProvider";
import PortUtils from "../../portlibs/PortUtils";
import Holding from "../../models/Holding";
import SummaryHolding from "../../models/SummaryHolding";
import { Cols, IHolding, IValue } from "../../shared/Consts";
import TableUtils from "../../portlibs/TableUtils";
import { useEffect, useState } from "react";
import Table from "../../gui/Table/Table";
import GUI from "../../gui/GUI";

export interface IHoldingTableProps {
    tableName:string;
    cols:string[];
    rows:Holding[];
    footer?:any
}

function className(holding:IHolding&IValue, col:string, val:string|number) {
    if (col==Cols.mwPercent) return holding.mwPercent>=0 ? "green" : "red"
    else if (col==Cols.holdingPercent) return holding.holdingPercent>=0 ? "green" : "red";
    else if (col==Cols.gain) return holding.gain>=0 ? "green" : "red";
    else if (col==Cols.profit) return holding.profit>=0 ? "green" : "red";
    else if (col==Cols.dividend) { return "blue" }
    else if (col==Cols.ugain) return holding.ugain>=0 ? "green" : "red";
    else return PortUtils.cellClass(col, val)
}

export default function HoldingTable(props:IHoldingTableProps){
    const {footer,...tableProps} = props
    const [compact,setCompact] = useState<boolean>(window.innerWidth<600)
    const {setPath, setHash} = usePath()
    const showHistory = (row:Holding) => setHash("/"+row.id)
    const gotoFixedIncome = () => setPath("/fixed")
    const cell = (row:Holding, col:string) => (col==Cols.name && compact) ? row.id : row.value(col, false)
    const cellProps = (row:Holding, col:string) => ( {className:GUI.joinClass(className(row,col,(row as any)[col]), TableUtils.align(col))} )
    const headerProps = (col:string) => ( { className:TableUtils.align(col)})
    const row = (row:Holding) => ({onClick:() =>  row instanceof SummaryHolding ? gotoFixedIncome() : showHistory(row)})
    const rowKey = (row:Holding) => row.id
    const onResize = () => setCompact(window.innerWidth<600)
    const rowcmp = (l:Holding, r:Holding, col:string, dir:number) => {
        const lCash = l.isCash, rCash = r.isCash
        if ( (lCash && rCash) || !(lCash || rCash) ) return l.rawValue(col, true) < r.rawValue(col, true) ? -dir : dir
        else if (lCash) return -1
        else return 1
    }
    useEffect(() => {
        window.addEventListener("resize", onResize)
        return () => { window.removeEventListener("resize", onResize)}
    }, [])
    return <Table {...tableProps} rowKey={rowKey} 
        footer={footer ? [footer] : undefined} 
        cellText={cell} td={cellProps} tr={row} 
        label={TableUtils.header} th={headerProps}
        rowcmp={rowcmp}/>
}